(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminSettingsController", adminSettingsController);

  adminSettingsController.$inject = [
    "alerts",
    "handleError",
    "SettingsApi",
    "siteSettingsPayload",
    "UploadsApi",
    "UsersApi",
    "NewsApi",
    "PromotionsApi",
    "$uibModal",
  ];

  function adminSettingsController(
    alerts,
    handleError,
    SettingsApi,
    siteSettingsPayload,
    UploadsApi,
    UsersApi,
    NewsApi,
    PromotionsApi,
    $uibModal,
  ) {
    var vm = this;

    // properties
    vm.settings = angular.copy(siteSettingsPayload);
    vm.loadingConfig = {
      show: false,
      message: "Saving...",
    };
    vm.formErrors = null;

    // methods
    vm.saveSettings = saveSettings;

    /**
     * Save site settings.
     *
     * @param {void}
     * @return {void}
     */
    function saveSettings() {
      vm.loadingConfig.show = true;

      var handleSaveSettingsSuccess = function () {
        vm.loadingConfig.show = false;
        alerts.emit({
          theme: "success",
          title: "Saved",
          messages: ["Settings"],
        });
      };
      var handleSaveSettingsError = function () {
        vm.loadingConfig.show = false;
        alerts.emit({
          theme: "error",
          title: "Could not save",
          messages: ["Please try again"],
        });
      };

      SettingsApi.save(
        {
          settings: vm.settings,
        },
        handleSaveSettingsSuccess,
        handleSaveSettingsError,
      ).suppressValidationAlerts();
    }
  }
})(angular);
